import { C, Res, type BuildingDef } from './types';

const B = C.Building;

export const BUILDINGS: BuildingDef[] = [
  {
    key: 'townCenter', name: 'Town Centre', cost: [0, 275, 0, 100], buildTime: 150, hp: 2400, armor: { melee: 3, pierce: 7 },
    size: 4, los: 8, pop: 10, age: 0, classes: B, dropoff: [Res.Food, Res.Wood, Res.Gold, Res.Stone],
    trains: ['villager'], researches: ['age2', 'age3', 'age4', 'age5', 'loom', 'wheelbarrow', 'handCart'], garrison: 15,
    attack: { melee: 0, pierce: 5, range: 6, cooldown: 2, projectile: 'arrow', projectileSpeed: 10, accuracy: 90 },
    model: { w: 3.8, d: 3.8, wallH: 1.15, roof: 'hip', tower: 2.3, chimney: true, banner: true, material: 'stone' },
    description: 'Seat of your civilisation. Trains villagers, accepts all resources and researches age advancements. Shelters up to 15 villagers, who double its arrows while inside.',
  },
  {
    key: 'house', name: 'House', cost: [0, 25, 0, 0], buildTime: 25, hp: 550, armor: { melee: 0, pierce: 7 },
    size: 2, los: 2, pop: 5, age: 0, classes: B,
    model: { w: 1.7, d: 1.5, wallH: 0.8, roof: 'gable', chimney: true, material: 'timber' },
    description: 'Provides 5 population.',
  },
  {
    key: 'farm', name: 'Farm', cost: [0, 60, 0, 0], buildTime: 15, hp: 480, armor: { melee: 0, pierce: 0 },
    size: 3, los: 1, pop: 0, age: 0, classes: B, foodAmount: 175,
    model: { w: 3, d: 3, wallH: 0, roof: 'none', field: true, fence: true },
    description: 'Renewable food source worked by a single villager.',
  },
  {
    key: 'lumberCamp', name: 'Lumber Camp', cost: [0, 100, 0, 0], buildTime: 35, hp: 600, armor: { melee: 1, pierce: 7 },
    size: 2, los: 2, pop: 0, age: 0, classes: B, dropoff: [Res.Wood], researches: ['doubleAxe', 'bowSaw'],
    model: { w: 1.9, d: 1.6, wallH: 0.7, roof: 'gable', material: 'timber' },
    description: 'Wood drop-off and forestry technologies.',
  },
  {
    key: 'miningCamp', name: 'Mining Camp', cost: [0, 100, 0, 0], buildTime: 35, hp: 600, armor: { melee: 1, pierce: 7 },
    size: 2, los: 2, pop: 0, age: 0, classes: B, dropoff: [Res.Gold, Res.Stone], researches: ['goldMining', 'stoneMining'],
    model: { w: 1.9, d: 1.6, wallH: 0.6, roof: 'flat', material: 'stone' },
    description: 'Gold and stone drop-off and mining technologies.',
  },
  {
    key: 'mill', name: 'Mill', cost: [0, 100, 0, 0], buildTime: 35, hp: 600, armor: { melee: 1, pierce: 7 },
    size: 2, los: 2, pop: 0, age: 0, classes: B, dropoff: [Res.Food], researches: ['horseCollar', 'heavyPlow'],
    model: { w: 1.8, d: 1.8, wallH: 1.1, roof: 'cone', material: 'plaster' },
    description: 'Food drop-off and agricultural technologies.',
  },
  {
    key: 'barracks', name: 'Barracks', cost: [0, 175, 0, 0], buildTime: 50, hp: 1200, armor: { melee: 0, pierce: 7 },
    size: 3, los: 3, pop: 0, age: 0, classes: B, trains: ['militia', 'spearman', 'scout', 'swordsman', 'pikeman'], researches: ['tracking'],
    model: { w: 2.8, d: 2.6, wallH: 1.0, roof: 'gable', banner: true, fence: true, material: 'timber' },
    description: 'Trains infantry.',
  },
  {
    key: 'watchtower', name: 'Watchtower', cost: [0, 50, 0, 75], buildTime: 60, hp: 700, armor: { melee: 1, pierce: 7 },
    size: 1, los: 16, pop: 0, age: 0, classes: B | C.Tower,
    attack: { melee: 0, pierce: 5, range: 7, cooldown: 2, projectile: 'arrow', projectileSpeed: 10, accuracy: 90, bonuses: [{ vs: C.Infantry, dmg: 1 }] },
    model: { w: 0.9, d: 0.9, wallH: 2.6, roof: 'cone', material: 'stone' },
    description: 'Lookout tower that fires arrows and sees much further than other buildings.',
  },
  {
    key: 'archeryRange', name: 'Archery Range', cost: [0, 175, 0, 0], buildTime: 50, hp: 1200, armor: { melee: 0, pierce: 7 },
    size: 3, los: 3, pop: 0, age: 1, classes: B, trains: ['archer', 'crossbowman', 'horseArcher', 'handCannoneer'], researches: ['thumbRing'],
    model: { w: 2.8, d: 2.6, wallH: 0.9, roof: 'hip', banner: true, fence: true, material: 'timber' },
    description: 'Trains archers and skirmishers.',
  },
  {
    key: 'stable', name: 'Stable', cost: [0, 175, 0, 0], buildTime: 50, hp: 1200, armor: { melee: 0, pierce: 7 },
    size: 3, los: 3, pop: 0, age: 1, classes: B, trains: ['lightCavalry', 'knight', 'cuirassier', 'dragoon'], researches: ['husbandry'],
    model: { w: 2.8, d: 2.6, wallH: 0.9, roof: 'gable', fence: true, material: 'timber' },
    description: 'Trains cavalry.',
  },
  {
    key: 'market', name: 'Market', cost: [0, 175, 0, 0], buildTime: 60, hp: 1500, armor: { melee: 0, pierce: 7 },
    size: 3, los: 3, pop: 0, age: 1, classes: B, researches: ['coinage', 'banking', 'guilds'],
    model: { w: 2.8, d: 2.8, wallH: 0.8, roof: 'flat', banner: true, material: 'plaster' },
    description: 'Exchanges resources and improves trade income.',
  },
  {
    key: 'blacksmith', name: 'Blacksmith', cost: [0, 150, 0, 0], buildTime: 40, hp: 1200, armor: { melee: 0, pierce: 7 },
    size: 3, los: 3, pop: 0, age: 1, classes: B,
    researches: ['forging', 'ironCasting', 'scaleMail', 'chainMail', 'paddedArmor', 'leatherArmor', 'fletching', 'bodkin'],
    model: { w: 2.6, d: 2.4, wallH: 0.9, roof: 'gable', chimney: true, material: 'stone' },
    description: 'Improves attack and armour of military units.',
  },
  {
    key: 'stoneWall', name: 'Stone Wall', cost: [0, 0, 0, 5], buildTime: 8, hp: 1800, armor: { melee: 8, pierce: 10 },
    size: 1, los: 2, pop: 0, age: 2, classes: B | C.Wall, buildable: false,
    model: { w: 1, d: 1, wallH: 1.2, roof: 'none', material: 'stone' },
    description: 'Durable fortification segment.',
  },
  {
    key: 'guardTower', name: 'Guard Tower', cost: [0, 50, 0, 125], buildTime: 70, hp: 1500, armor: { melee: 2, pierce: 8 },
    size: 1, los: 12, pop: 0, age: 1, classes: B | C.Tower,
    attack: { melee: 0, pierce: 7, range: 8, cooldown: 2, projectile: 'arrow', projectileSpeed: 10, accuracy: 90, bonuses: [{ vs: C.Infantry, dmg: 2 }] },
    model: { w: 1, d: 1, wallH: 3.0, roof: 'cone', keep: true, material: 'stone' },
    description: 'Fortified tower; fires one more arrow per volley in each age after the Feudal Age.',
  },
  {
    key: 'castle', name: 'Castle', cost: [0, 0, 0, 650], buildTime: 200, hp: 4800, armor: { melee: 8, pierce: 11 },
    size: 4, los: 11, pop: 20, age: 2, classes: B, trains: ['trebuchet'], researches: ['conscription', 'hoardings'], limit: 0,
    attack: { melee: 0, pierce: 11, range: 8, cooldown: 2, projectile: 'arrow', projectileSpeed: 10, accuracy: 90 },
    model: { w: 4, d: 4, wallH: 2.0, roof: 'flat', keep: true, tower: 3.0, banner: true, material: 'stone' },
    description: 'Fortress that trains unique units and trebuchets.',
  },
  {
    key: 'siegeWorkshop', name: 'Siege Workshop', cost: [0, 200, 0, 0], buildTime: 40, hp: 1500, armor: { melee: 1, pierce: 7 },
    size: 3, los: 3, pop: 0, age: 2, classes: B, trains: ['ram', 'mangonel', 'bombard'],
    model: { w: 2.9, d: 2.7, wallH: 1.0, roof: 'gable', chimney: true, material: 'timber' },
    description: 'Builds siege engines.',
  },
  {
    key: 'university', name: 'University', cost: [0, 200, 0, 0], buildTime: 60, hp: 2100, armor: { melee: 2, pierce: 8 },
    size: 3, los: 3, pop: 0, age: 2, classes: B, trains: ['engineer'], researches: ['masonry', 'ballistics', 'chemistry', 'architecture'],
    model: { w: 2.8, d: 2.8, wallH: 1.3, roof: 'dome', material: 'stone' },
    description: 'Researches advanced building and ballistic technologies; trains engineers.',
  },
  {
    key: 'monastery', name: 'Monastery', cost: [0, 175, 0, 0], buildTime: 40, hp: 2100, armor: { melee: 3, pierce: 9 },
    size: 3, los: 4, pop: 0, age: 2, classes: B, trains: ['monk'], researches: ['fervor'],
    model: { w: 2.8, d: 2.6, wallH: 1.2, roof: 'gable', tower: 2.4, material: 'stone' },
    description: 'Centre of learning and faith; trains monks and improves unit vitality.',
  },
  {
    key: 'dock', name: 'Dock', cost: [0, 150, 0, 0], buildTime: 35, hp: 1800, armor: { melee: 0, pierce: 7 },
    size: 3, los: 5, pop: 0, age: 0, classes: B, dropoff: [Res.Food], trains: ['fishingShip', 'galley', 'frigate', 'caravel', 'caravelle'],
    model: { w: 2.8, d: 2.8, wallH: 0.6, roof: 'gable', material: 'timber' },
    description: 'Built on the shoreline. Trains ships and receives fish.',
  },
  {
    key: 'arsenal', name: 'Arsenal', cost: [0, 250, 100, 0], buildTime: 60, hp: 2000, armor: { melee: 2, pierce: 8 },
    size: 3, los: 4, pop: 0, age: 4, classes: B, trains: ['lineInfantry', 'rifleman'], researches: ['rifling', 'drill'],
    model: { w: 3, d: 2.7, wallH: 1.1, roof: 'hip', chimney: true, banner: true, material: 'brick' },
    description: 'Trains industrial-era gunpowder infantry.',
  },
  {
    key: 'foundry', name: 'Foundry', cost: [0, 200, 200, 50], buildTime: 70, hp: 2000, armor: { melee: 2, pierce: 8 },
    size: 3, los: 3, pop: 0, age: 4, classes: B, trains: ['fieldArtillery', 'heavyArtillery'], researches: ['shrapnel'],
    model: { w: 3, d: 2.8, wallH: 1.2, roof: 'flat', chimney: true, material: 'brick' },
    description: 'Casts artillery.',
  },
  {
    key: 'industrialWorkshop', name: 'Industrial Workshop', cost: [0, 200, 150, 0], buildTime: 60, hp: 1800, armor: { melee: 1, pierce: 8 },
    size: 3, los: 3, pop: 0, age: 4, classes: B, dropoff: [Res.Wood, Res.Gold, Res.Stone], researches: ['steamPower', 'factorySystem'],
    model: { w: 3, d: 2.6, wallH: 1.0, roof: 'gable', chimney: true, material: 'brick' },
    description: 'Industrial production; accepts wood, gold and stone.',
  },
  {
    key: 'logisticsDepot', name: 'Logistics Depot', cost: [0, 200, 100, 0], buildTime: 50, hp: 1600, armor: { melee: 1, pierce: 7 },
    size: 3, los: 4, pop: 10, age: 4, classes: B, dropoff: [Res.Food, Res.Wood, Res.Gold, Res.Stone], researches: ['railways'],
    model: { w: 3, d: 2.6, wallH: 0.9, roof: 'flat', fence: true, material: 'brick' },
    description: 'Accepts all resources and supports 10 population.',
  },
  {
    key: 'wonder', name: 'Wonder', cost: [1000, 1000, 1000, 1000], buildTime: 600, hp: 6000, armor: { melee: 4, pierce: 10 },
    size: 5, los: 8, pop: 0, age: 3, classes: B, limit: 1,
    model: { w: 5, d: 5, wallH: 2.4, roof: 'pyramid', tower: 4.5, keep: true, banner: true, material: 'stone' },
    description: 'A monument to your civilisation. Defend it to achieve a Wonder Victory.',
  },
];

/**
 * Wall pieces, placed as lines with the Wall tool rather than one by one (see gameplay/walls.ts).
 * Registered after resources so existing kind indices (and saves) are unchanged.
 */
export const WALL_PIECES: BuildingDef[] = [
  {
    key: 'fence', name: 'Wooden Fence', cost: [0, 2, 0, 0], buildTime: 3, hp: 250, armor: { melee: 2, pierce: 5 },
    size: 1, los: 1, pop: 0, age: 0, classes: B | C.Wall, buildable: false,
    model: { w: 1, d: 1, wallH: 0.7, roof: 'none', material: 'timber' },
    description: 'Cheap timber fence that slows raiders.',
  },
  {
    key: 'fencePost', name: 'Fence Post', cost: [0, 4, 0, 0], buildTime: 5, hp: 400, armor: { melee: 3, pierce: 6 },
    size: 1, los: 2, pop: 0, age: 0, classes: B | C.Wall, buildable: false,
    model: { w: 1, d: 1, wallH: 0.9, roof: 'none', material: 'timber' },
    description: 'Braced timber post joining fence sections.',
  },
  {
    key: 'stonePillar', name: 'Stone Pillar', cost: [0, 0, 0, 6], buildTime: 8, hp: 1400, armor: { melee: 8, pierce: 10 },
    size: 1, los: 3, pop: 0, age: 1, classes: B | C.Wall, buildable: false,
    model: { w: 1, d: 1, wallH: 1.4, roof: 'none', material: 'stone' },
    description: 'Masonry pillar anchoring fence and wall sections.',
  },
];
